import React from "react";
import { styled } from "@linaria/react";
import { color, fonts, radius } from "@ui";
import Popper from "@ui/Popper";
import useToasts from "@ui/Toast/useToasts";
import t from "../../../../../i18n";
import { FileCopyLine } from "@ui/IconV2/react";
import ButtonIconV2 from "@ui/ButtonIconV2";

interface P {
  logs: string;
}

const ErrorHeader = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
  margin-bottom: 8px;
`;

const ErrorTitle = styled.div`
  color: ${color.carbon900};
  font: ${fonts.body1SemiBold};
`;

const ErrorDescription = styled.div`
  background-color: ${color.titanium50};
  border: 1px solid ${color.titanium100};
  border-radius: ${radius};
  white-space: pre;
  color: ${color.carbon900};
  font: ${fonts.body1};
  padding: 16px;
  overflow: hidden;
`;

const StyledPopper = styled(Popper)`
  border-radius: 4px;
  font: ${fonts.body2};
  max-width: 200px;
  padding: 12px;
  color: ${color.hydrogen};
  opacity: 0.9;
  box-shadow: 0px 7px 6px #00000029;
`;

function ErrorLog({ logs }: P) {
  const { addToast } = useToasts();

  const handleCopyClick = React.useCallback(async () => {
    if (logs === null) {
      throw new Error("Error string is null");
    }
    await window.navigator.clipboard.writeText(logs);
    addToast("success", t("setup.paragraphs.model.error.copied"));
  }, [addToast, logs]);

  return (
    <>
      <ErrorHeader>
        <ErrorTitle>{t("setup.paragraphs.model.error")}</ErrorTitle>
        <StyledPopper
          hover
          overlay={t("setup.paragraphs.model.error.copy")}
          gap={5}
          arrowWidth={0}
          placement="top"
          backgroundColor={color.darkNitrogen900}
        >
          <div>
            <ButtonIconV2 onClick={handleCopyClick}>
              <FileCopyLine size="s" />
            </ButtonIconV2>
          </div>
        </StyledPopper>
      </ErrorHeader>
      <ErrorDescription>{logs.split("\n").splice(0, 10).concat("...").join("\n")}</ErrorDescription>
    </>
  );
}

export default React.memo(ErrorLog);
